import { Stack } from 'expo-router';
import * as Header from '@/components/Custom/Header';
import Icon from '@/components/Unistyles/Icon';
import TeamDetailLayout from '@/layouts/TeamDetail';
import useRootStore, { openDrawer } from '@/stores/useRootStore';

export default function PrivateTabsTeamMainLayoutRoute() {
  const teamId = useRootStore((state) => state.teamId);

  const headerLeft = () => (
    <Header.Start>
      <Header.Button
        accessibilityLabel="Open navigation"
        testID="OpenNavigationButton"
        onPress={openDrawer}
      >
        <Icon name="menu-outline" size="3xl" />
      </Header.Button>
    </Header.Start>
  );

  return (
    <>
      <Stack.Screen options={{ headerLeft }} />
      <TeamDetailLayout
        basePath="/team"
        badgesPathname="/team/badges"
        teamId={teamId || ''}
      />
    </>
  );
}

export const unstable_settings = {
  initialRouteName: 'index',
};
